// extracted by mini-css-extract-plugin
export var animationContainer = "_im-0";
export var footer = "_im-1";
export var gray = "_im-2";
export var lineItem = "_im-3";
export var lineItemImage = "_im-4";
export var lineItemInfo = "_im-5";
export var lineItemText = "_im-6";
export var lineItems = "_im-7";
export var modalContent = "_im-8";
export var options = "_im-9";
export var orderName = "_im-a";
export var refundAmount = "_im-b";